export default __webpack_public_path__ + "static/media/logo_menu.264b3c86.svg";